export default "__VITE_ASSET__CP44upT2__"